const fonts = {
  default: {
    fontSize: 14,
    lineHeight: 18,
    fontWeight: 400
  },
  heading: {
    fontSize: 24,
    lineHeight: 28,
    fontWeight: 600,
    fontFamily: "Barlow Condensed"
  },
  label: {
    fontSize: 16,
    lineHeight: 19,
    fontWeight: 500
  },
  bold: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: 600
  },
  body: {
    fontSize: 24,
    lineHeight: 28,
    fontWeight: 800
  }
};

export default fonts;
